/**
 * Lifetime of EMAIL_UNLOCK_COOKIE, in seconds. One year — an email capture is a
 * durable signal, not a session thing.
 *
 * Lives in its own module because lib/email-unlock-cookie.ts imports node
 * `crypto` for the HMAC and can never be pulled into a browser bundle, while
 * the client-side tier hint (lib/analytics/user-tier.ts) must expire on exactly
 * this clock or it can outlive the cookie it is inferring.
 */
export const EMAIL_UNLOCK_MAX_AGE = 60 * 60 * 24 * 365
